import React, { useState, useEffect, useCallback } from "react";
import { useWorkplace } from "../context/WorkplaceContext";
import apiClient from "../apiClient";
import SvgIcons from "../layouts/SvgIcons";

const Left = React.memo(() => {
  const [areas, setAreas] = useState([]);
  const [expandedAreaIds, setExpandedAreaIds] = useState([]);
  const { selectedWorkplaceId, setSelectedWorkplaceId } = useWorkplace();

  const fetchWorkplaces = useCallback(async () => {
    try {
      const params = {
        Page: 1,
        PageSize: 100,
        OrderType: 1,
        LoginUserId: localStorage.getItem("userid") || "defaultUser",
        RecordCount: 0,
      };

      const response = await apiClient.post(
        "/api/WorkPlace/all-workplace-list",
        params
      );

      const data =
        typeof response.data === "string"
          ? JSON.parse(response.data)?.data || []
          : response.data?.data || [];

      console.log(response.data);

      const groupedData = data.reduce((acc, curr) => {
        const areaId = curr.areaId;
        if (!acc[areaId]) {
          acc[areaId] = { areaName: curr.areaName, workplaces: [] };
        }
        acc[areaId].workplaces.push({
          workplaceId: curr.workplaceId,
          workplaceName: curr.workplaceName,
          activateYn: curr.activateYN,
          createdDtm: curr.createdDtm,
          inCnt: curr.inCnt,
          Addr: curr.addr,
          Latitude: curr.latitude,
          Longitude: curr.longitude,
        });
        return acc;
      }, {});

      const areasData = Object.keys(groupedData).map((key) => ({
        areaId: key,
        areaName: groupedData[key].areaName,
        workplaces: groupedData[key].workplaces,
      }));

      setAreas(areasData);
      setExpandedAreaIds(areasData.map((area) => area.areaId));

      // 이미 선택된 현장이 없거나, 새로 받아온 데이터에 존재하지 않으면 초기값 설정
      if (
        (!selectedWorkplaceId ||
          !areasData.some((area) =>
            area.workplaces.find(
              (workplace) => workplace.workplaceId === selectedWorkplaceId
            )
          )) &&
        areasData.length > 0 &&
        areasData[0].workplaces.length > 0
      ) {
        setSelectedWorkplaceId(areasData[0].workplaces[0].workplaceId);
      }
    } catch (error) {
      console.error("Failed to fetch workplaces:", error);
    }
  }, [selectedWorkplaceId, setSelectedWorkplaceId]);

  useEffect(() => {
    fetchWorkplaces();
  }, [fetchWorkplaces]);

  // 5초마다 자동 새로고침
  useEffect(() => {
    const interval = setInterval(() => {
      fetchWorkplaces();
    }, 5000);
    return () => clearInterval(interval);
  }, [fetchWorkplaces]);

  const handleAreaClick = (areaId) => {
    setExpandedAreaIds((prev) =>
      prev.includes(areaId)
        ? prev.filter((id) => id !== areaId)
        : [...prev, areaId]
    );
  };

  const handleWorkplaceClick = (workplaceId) => {
    setSelectedWorkplaceId(workplaceId);
  };

  return (
    <div className="bodyleft">
      <div className="leftnav">
        {areas.map((area) => (
          <div key={area.areaId} className="leftgroup">
            <div className="title" onClick={() => handleAreaClick(area.areaId)}>
              <div>{area.areaName}</div>
              <div>
                {expandedAreaIds.includes(area.areaId) ? (
                  <SvgIcons icon="chevroff" />
                ) : (
                  <SvgIcons icon="chevron" />
                )}
              </div>
            </div>
            {expandedAreaIds.includes(area.areaId) && (
              <div className="btns">
                {area.workplaces.map((workplace) => (
                  <a
                    role="button"
                    key={workplace.workplaceId}
                    className={`btn ${
                      selectedWorkplaceId === workplace.workplaceId ? "on" : ""
                    }`}
                    onClick={() => handleWorkplaceClick(workplace.workplaceId)}
                  >
                    <div className="column">
                      <div className="square"></div>
                    </div>
                    <div className="column">
                      <div className="name">{workplace.workplaceName}</div>
                      <div className="stats">
                        {/* <div className="stat">정상</div> */}
                        <div className="stay">체류인원: {workplace.inCnt}</div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* <div className="leftnav">
      <div className="title">
        <div>서울경기</div>
        <div><SvgIcons icon="chevron" /></div>
      </div>
      <div className="btns">
        <a className="btn on">
          <div className="column">
            <div className="square"></div>
          </div>
          <div className="column">
            <div className="name">경기지역 전력구</div>
            <div className="stats">
              <div className="stat">정상</div>
              <div className="stay">/ 입실중: 78</div>
            </div>
          </div>
        </a>
        <a className="btn">
          <div className="column">
            <div className="square color3b"></div>
          </div>
          <div className="column">
            <div className="name">충남지역 전력구</div>
            <div className="stats">
              <div className="stat color3">주의</div>
              <div className="stay">/ 입실중: 2</div>
            </div>
          </div>
        </a>
        <a className="btn">
          <div className="column">
            <div className="square color4b"></div>
          </div>
          <div className="column">
            <div className="name">전북지역 전력구</div>
            <div className="stats">
              <div className="stat color4">위험</div>
              <div className="stay">/ 입실중: 5</div>
            </div>
          </div>
        </a>
        <a className="btn">
          <div className="column">
            <div className="square color5b"></div>
          </div>
          <div className="column">
            <div className="name">강원지역 전력구</div>
            <div className="stats">
              <div className="stat color5">화재</div>
              <div className="stay">/ 입실중: 57</div>
            </div>
          </div>
        </a>
      </div>
      <div className="title">
        <div>영동지역</div>
        <div><SvgIcons icon="chevron" /></div>
      </div>
      <div className="btns">
        <a className="btn">
          <div className="column">
            <div className="square"></div>
          </div>
          <div className="column">
            <div className="name">부산지역 전력구</div>
            <div className="stats">
              <div className="stat">정상</div>
              <div className="stay">/ 입실중: 20</div>
            </div>
          </div>
        </a>
        <a className="btn">
          <div className="column">
            <div className="square color2b"></div>
          </div>
          <div className="column">
            <div className="name">전남지역 전력구</div>
            <div className="stats">
              <div className="stat color2">점검</div>
              <div className="stay">/ 입실중: 36</div>
            </div>
          </div>
        </a>
      </div>
    </div> */}
      <div className="leftfooter"></div>
    </div>
  );
});

export default Left;
